<template>
  <div v-if="item" class="p-8 b-counterparty-content">
    <div class="mb-8 b-counterparty-content__main-info">
      <div class="mb-2 b-counterparty-content__top">
        <h2 data-cy="content-display-name">{{item.getDisplayName()}}</h2>
        <button v-if="!isReadOnlyMode" data-cy="edit-button" class="b-btn  b-btn__icon_color_main-text" @click="editCounterparty">
          <dynamic-icon icon="edit" class="b-btn__icon"></dynamic-icon>
          {{$t('CONTENT.contract.edit')}}
        </button>
      </div>
      <div class="mb-4 b-counterparty-content__info-checked">
        <div data-cy="content-vgo" v-if="item.isIntragroupTurnover" class="b-counterparty-content__info-checked-item">
          <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
          {{$t('CONTENT.counterparty.VGO')}}
        </div>
        <div data-cy="content-vat" v-if="lastVatHistory.isSubjectToVAT" class="b-counterparty-content__info-checked-item">
          <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
          {{$t('CONTENT.counterparty.hasVAT')}}
        </div>
        <div data-cy="content-vat" v-if="lastVatHistory.isSubjectToVAT" class="b-counterparty-content__info-checked-item">
          {{$t('CONTENT.counterparty.rateVAT')}} {{ lastVatHistory.rateVAT }}%
        </div>
      </div>
      <div class="b-counterparty-content__info-codes-wrap">
        <div v-if="item.itn" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">{{$t('CONTENT.counterparty.itn')}}:</div>
          <div data-cy="content-itn" class="b-counterparty-content__info-codes-value">{{item.itn}}</div>
        </div>
        <div v-if="item.rrc" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">{{$t('CONTENT.counterparty.rrc')}}:</div>
          <div data-cy="content-rrc" class="b-counterparty-content__info-codes-value">{{item.rrc}}</div>
        </div>
        <div v-if="item.ogrn" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">{{$t('CONTENT.counterparty.ogrn')}}:</div>
          <div data-cy="content-ogrn" class="b-counterparty-content__info-codes-value">{{item.ogrn}}</div>
        </div>
        <div v-if="item.externalId" class="b-counterparty-content__info-codes">
          <div class="mr-2 b-counterparty-content__info-codes-name">{{$t('CONTENT.external_id')}}:</div>
          <div data-cy="content-external-id" class="b-counterparty-content__info-codes-value">{{item.externalId}}</div>
        </div>
      </div>
    </div>
    <div class="b-counterparty-content__info-wrap">
      <div v-if="item.russianPassport">
        <div v-if="item.russianPassport.passportSerialNumber" class="mb-4 b-counterparty-content__info">
          <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.series_and_passport_number')}}</div>
          <div data-cy="content-passport-serial-and-number" class="b-counterparty-content__info-text">{{item.russianPassport.passportSerialNumber}} {{item.russianPassport.passportNumber}}</div>
        </div>
        <div v-if="item.russianPassport.issuer" class="mb-4 b-counterparty-content__info">
          <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.issuer')}}</div>
          <div data-cy="content-passport-issuer" class="b-counterparty-content__info-text">{{item.russianPassport.issuer}}</div>
        </div>
        <div v-if="item.russianPassport.dayDateDateOfIssue" class="mb-4 b-counterparty-content__info">
          <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.passport_date')}}</div>
          <div data-cy="content-passport-date" class="b-counterparty-content__info-text">{{item.getRussianPassportDate()}}</div>
        </div>
        <div v-if="item.russianPassport.divisionCode" class="mb-4 b-counterparty-content__info">
          <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.passport_code')}}</div>
          <div data-cy="content-passport-division-code" class="b-counterparty-content__info-text">{{item.russianPassport.divisionCode}}</div>
        </div>
      </div >
      <div v-if="item.shortName" class="mb-4 b-counterparty-content__info">
        <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.shortCompanyName')}}</div>
        <div data-cy="content-short-name" class="b-counterparty-content__info-text">{{item.shortName}}</div>
      </div>
      <div v-if="item.latinName" class="mb-4 b-counterparty-content__info">
        <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.latinCompanyName')}}</div>
        <div data-cy="content-latin-name" class="b-counterparty-content__info-text">{{item.latinName}}</div>
      </div>
      <div v-if="item.addresses.length !== 0">
        <div v-for="addressItem in item.addresses">
          <div v-if="addressItem.addressType === 'Legal' && addressItem.address !== ''" class="mb-4 b-counterparty-content__info">
            <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.legal_address')}}</div>
            <div data-cy="content-address-legal" class="b-counterparty-content__info-text">{{addressItem.address}}</div>
          </div>
          <div v-if="addressItem.addressType === 'Actual' && addressItem.address !== ''" class="mb-4 b-counterparty-content__info">
            <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.actual_address')}}</div>
            <div data-cy="content-address-actual" class="b-counterparty-content__info-text">{{addressItem.address}}</div>
          </div>
          <div v-if="addressItem.addressType === 'Mail' && addressItem.address !== ''" class="mb-4 b-counterparty-content__info">
            <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.counterparty.mail_address')}}</div>
            <div data-cy="content-address-mail" class="b-counterparty-content__info-text">{{addressItem.address}}</div>
          </div>
        </div>
      </div>
      <div v-if="item.comment" class="mb-4 b-counterparty-content__info">
        <div class="mb-1 b-counterparty-content__info-subtitle">{{$t('CONTENT.comment')}}:</div>
        <div data-cy="content-comment" class="b-counterparty-content__info-text">{{item.comment}}</div>
      </div>
      <div v-if="history.length" class="b-counterparty-content__info-codes-wrap">
        <div v-for="(entry, index) in history" :key="index" class="b-counterparty-content__info-codes">
          <div class="mr-1 b-counterparty-content__info-codes-name">
            {{$t('CONTENT.counterparty.counterparty_type')}}
          </div>
          <div class="mr-2 b-counterparty-content__info-codes-value">
            {{ entry.counterpartyInGroupType == 1 ? $t('CONTENT.reportPage.Vgo') : $t('CONTENT.reportPage.Related') }}
          </div>
          <div class="mr-1 b-counterparty-content__info-codes-name">
            {{$t('CONTENT.contract.event_date')}}:
          </div>
          <div class="mr-2 b-counterparty-content__info-codes-value">
            {{ entry.eventDate.day }}.{{ entry.eventDate.month }}.{{ entry.eventDate.year }}
          </div>
          <div class="mr-1 b-counterparty-content__info-codes-name">
            {{$t('CONTENT.counterparty.date_type_change')}}:
          </div>
          <div class="mr-2 b-counterparty-content__info-codes-value">
            {{ entry.changeDate.day }}.{{ entry.changeDate.month }}.{{ entry.changeDate.year }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
	export default {
		props: {
			item: {
        required: true,
        default: null
      },
      isReadOnlyMode: {
        type: Boolean
      },
      history: {
        type: Array
      },
    },
    computed: {
      lastVatHistory() {
        if (
          !this.item ||
          !Array.isArray(this.item.counterpartyVatHistoryList) ||
          this.item.counterpartyVatHistoryList.length === 0
        ) {
          return null
        }

        return [...this.item.counterpartyVatHistoryList]
          .sort((a, b) => new Date(b.dateOfChange) - new Date(a.dateOfChange))[0]
      }
    },
    methods: {
			editCounterparty() {
				this.$emit('edit');
      }
    }
	}
</script>
